import { useEffect } from "react";
import { Subscription, timer } from "rxjs";
import { DevFeatures } from "@nxplatform/helpers/dev-features";
import { AppIntervals } from "@nxplatform/helpers/timings";
import { customerAuthTokenName } from "@service/api-client/token/token-action";
import { useFeatureChecker } from "../../hooks/feature-provider-version.js";
const useCustomerData = ({
  customer,
  wsActive,
  loaded,
  disabledPromotions,
  confirmationSuccess,
  changeBonusType,
  getCustomerInfo,
  getPromotionsList,
  customerSocket,
  tokenLogin,
  setRegistrationSuccess,
  confirmationSuccessCallback = () => {
  },
  markUserActivity
}) => {
  const { id } = customer || {};
  const { isActive } = useFeatureChecker(DevFeatures.DW3425);
  useEffect(() => {
    window.onstorage = (event) => {
      if (event.key === customerAuthTokenName) {
        getCustomerInfo();
        getPromotionsList(null, customer.disabledStatusCode);
      }
    };
  }, []);
  useEffect(() => {
    const subscription = new Subscription();
    if (id && loaded) {
      changeBonusType(customer.bonusType);
      customerSocket(customer, wsActive);
      if (isActive) {
        subscription.add(
          timer(AppIntervals.userActivity, AppIntervals.userActivity).subscribe(markUserActivity)
        );
      } else {
        subscription.add(
          timer(0, AppIntervals.checkBalance).subscribe(() => getCustomerInfo())
        );
      }
      getPromotionsList(disabledPromotions, customer.disabledStatusCode);
    }
    return () => {
      subscription.unsubscribe();
    };
  }, [id, getCustomerInfo, disabledPromotions, loaded, wsActive, markUserActivity]);
  useEffect(() => {
    if (confirmationSuccess) {
      tokenLogin(confirmationSuccess);
      setRegistrationSuccess();
      confirmationSuccessCallback();
    }
  }, [confirmationSuccess]);
};
export {
  useCustomerData
};
